import { request_list } from '@/commons/hpod';
import Vue from 'vue';
import config from '@/configs'

const state = {
    tiers: [],
    staffConfigs: [],
    loading: false
};

const getters = {};

const actions = {
    getTiers({ commit }) {
        commit('setLoading', { loading: true });
        request_list('sale-commission-config/tiers', data => {
            commit('setTiers', data.data || []);
            commit('setLoading', { loading: false });
        }, Vue.http, {}, this.state.authentication.token);
    },

    saveTier({ commit, dispatch }, { tier, pk }) {
        commit('setLoading', { loading: true });
        const method = pk ? 'post' : 'put';
        const url = pk
            ? `${config.API}/api/sale-commission-config/tiers/${pk}`
            : `${config.API}/api/sale-commission-config/tiers/`;
        return Vue.http[method](url, tier, {
            headers: { Authorization: `Bearer ${this.state.authentication.token}` }
        }).then(() => {
            dispatch('getTiers');
        }).finally(() => {
            commit('setLoading', { loading: false });
        });
    },

    deleteTier({ commit, dispatch }, pk) {
        commit('setLoading', { loading: true });
        Vue.http.delete(
            `${config.API}/api/sale-commission-config/tiers/${pk}`,
            { headers: { Authorization: `Bearer ${this.state.authentication.token}` } }
        ).then(() => {
            dispatch('getTiers');
        }).finally(() => {
            commit('setLoading', { loading: false });
        });
    },

    getStaffConfigs({ commit }) {
        commit('setLoading', { loading: true });
        request_list('sale-commission-config/staff', data => {
            commit('setStaffConfigs', data.data || []);
            commit('setLoading', { loading: false });
        }, Vue.http, {}, this.state.authentication.token);
    },

    saveStaffConfig({ commit, dispatch }, staffData) {
        commit('setLoading', { loading: true });
        return Vue.http.post(
            `${config.API}/api/sale-commission-config/staff/`,
            staffData,
            { headers: { Authorization: `Bearer ${this.state.authentication.token}` } }
        ).then(() => {
            dispatch('getStaffConfigs');
        }).finally(() => {
            commit('setLoading', { loading: false });
        });
    }
};

const mutations = {
    setTiers(state, tiers) {
        state.tiers = tiers;
    },
    setStaffConfigs(state, configs) {
        state.staffConfigs = configs;
    },
    setLoading(state, { loading }) {
        state.loading = loading;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
